import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * Per-user extraction statistics: the same counters as the global
 * MailProcessingStats, grouped by the sender (the H&D employee who forwarded
 * the request). Only known users are reported (sender address matches a user
 * e-mail); external direct mails are not attributed to any user.
 */
@Entity()
export class MailProcessingUserStats extends AdornisEntity {
  static override _class = 'MailProcessingUserStats';

  @Field(() => String)
  senderAddress?: Maybe<string>;

  @Field(() => String)
  userName?: Maybe<string>;

  @Field(() => Int)
  sumExtractions?: number;

  @Field(() => Int)
  sumCorrect?: number;

  @Field(() => Int)
  sumIncorrect?: number;

  @Field(() => Int)
  sumNotEvaluated?: number;

  @Field(() => Int)
  sumCorrectAfterCorrection?: number;

  @Field(() => Int)
  sumCorrectWithAdjustment?: number;

  @Field(() => Int)
  sumUnsolvable?: number;

  constructor(doc: PartialEntityData<MailProcessingUserStats>) {
    super(doc);
  }
}
